import { ReturnStatus } from "@/types/enum/notification";

const error = {
    addReminder: 'Bestellwecker konnte keiner Liste zugewiesen werden',
    noMatch: `{target} stimmt nicht überein`,
    notFound: "{target} wurde nicht gefunden. | {target} wurden nicht gefunden.",
    invalid: "{target} ist nicht korrekt. | {target} sind nicht korrekt.",
    empty: "{target} ist leer. | {target} sind leer.",
    noAuth: "{target} hat keine Berechtigung. | {target} haben keine Berechtigung.",
    noAdmin: "Keine Adminberechtigung gefunden.",
    addCart: "Produkt konnte nicht zum Warenkorb hinzugefügt werden. | Produkte konnten nicht zum Warenkorb hinzugefügt werden.",
    addPromoPackage: "Das Aktionspaket wurde nicht oder nur teilweise zum Warenkorb hinzugefügt.",
    addList: "Produkt konnte nicht zur Liste hinzugefügt werden. | Produkte konnten nicht zur Liste hinzugefügt werden.",
    create: "{target} konnte nicht erstellt werden. | {target} konnten nicht erstellt werden.",
    order: "Bestellung konnte nicht ausgeführt werden.",
    save: '{target} konnte nicht gespeichert werden.',
    delete: '{target} konnte nicht gelöscht werden.',
    deleteUser: 'Benutzer konnte nicht gelöscht werden.',
    resendMail: 'Email konnte nicht erneut versendet werden.',
    sendLink: 'Link konnte nicht versendet werden.',
    removeProduct: 'Produkt konnte nicht vom Warenkorb entfernt werden. | Produkte konnte nicht vom Warenkorb entfernt werden.',
    //just for testing
    registerFalse: 'Registrierung fehlgeschlagen.',
    loginFalse: 'Login fehlgeschlagen.',
    locationFalse: 'Anlegen der Location fehlgeschlagen.',
    orderFinish: 'Bestellung konnte nicht erstellt werden.',
    send: '{target} konnte nicht versendet werden.',
    loadSupplier: 'Lieferant konnte nicht geladen werden | Lieferanten konnten nicht geladen werden.',
    loadLists: 'Listen konnten nicht geladen werden.',
    load: '{target} konnte nicht geladen werden. | {target} konnten nicht geladen werden.',
    sendTicket: 'Das Feedback konnte nicht versendet werden.',
    scanBarcode: 'Der gescannte Barcode ist ungültig.',
    promotionLimitReached: 'Max. Aktionsmenge erreicht',
    aiCall: '@:error.returnType.Unknown',
    ajv: {
        required: 'Pflichtfelder sind nicht ausgefüllt',
        format: 'Eingabe war nicht korrekt: Die eingabe sollte im Format {formatInfo} sein',
        formatInfo: {
            date: 'Datum',
            time: 'Zeit',
            email: 'Email',
            "date-time": 'Datum & Zeit'
        },
        oneOf: 'Eingabe stimmt mit keinem der möglichen Werte überein',
        minimum: 'Eingabe unterschreitet minimum von {min}',
        maximum: 'Eingabe überschreitet maximum von {max}',
        enum: 'Eingabe enthält nicht einen der möglichen Werten'
    },
    returnType: {
        [ReturnStatus.UNKNOWN]: 'Ein Fehler ist aufgetreten',
        [ReturnStatus.BAD_REQUEST]: 'Anfrage enthält fehlerhafte Daten',
        [ReturnStatus.NOT_FOUND]: 'Anfrage hat kein Element gefunden.',
        [ReturnStatus.UNAUTHORIZED]: 'Fehlende Berechtigung',
        [ReturnStatus.FORBIDDEN]: 'Anfrage ist nicht erlaubt',
        [ReturnStatus.NOT_IMPLEMENTED]: 'Anfrage ist nicht implementiert',
        [ReturnStatus.INVALID_LOGIN]: 'Ungültiges Login',
        [ReturnStatus.INVALID_SESSION]: 'Ungültige Session',
        [ReturnStatus.INVALID_PASSWORD]: 'Ungültiges Passwort',
        [ReturnStatus.USER_NOT_FOUND]: 'Benutzer nicht gefunden',
        [ReturnStatus.USER_ALREADY_EXISTS]: 'Benutzer existiert schon',
        [ReturnStatus.USER_EMAIL_ALREADY_EXISTS]: 'Es existiert schon ein Benutzer mit dieser Email',
        [ReturnStatus.LOCATION_NOT_FOUND]: 'Location nicht gefunden',
        [ReturnStatus.CART_ITEM_NOT_FOUND]: 'Produkt nicht gefunden',
        [ReturnStatus.ITEM_ALREADY_IN_CART]: 'Produkt ist schon im Einkaufswagen, bearbeite deine Auswahl im Warenkorb',
        [ReturnStatus.LIST_ALREADY_IN_CART]: 'Liste ist schon im Einkaufswagen, bearbeite deine Auswahl im Warenkorb. ' +
        'Die Liste kann erst bearbeitet werden sobald die Liste im Warenkorb bestellt wurd.',
        [ReturnStatus.LIST_CANT_BE_DELETED]: 'Liste kann nicht gelöscht werden.',
        [ReturnStatus.LIST_EMPTY]: 'Die Liste ist leer. Prüfe ob mindestens ein Produkt eine Menge von mehr als 0 hat.',
        [ReturnStatus.SUPPLIER_NOT_FOUND]: 'Lieferant nicht gefunden',
        [ReturnStatus.SUPPLIER_ITEM_NOT_FOUND]: 'Lieferanten-Produkt nicht gefunden',
        [ReturnStatus.ORDER_NOT_FOUND]: 'Bestellung nicht gefunden',
        [ReturnStatus.LIST_NOT_FOUND]: 'Liste nicht gefunden',
        [ReturnStatus.LIST_ITEM_NOT_FOUND]: 'Listenprodukt nicht gefunden',
        [ReturnStatus.ITEM_ALREADY_IN_LIST]: 'Produkt ist schon in Liste, bearbeite deine Auswahl in der Liste',
        [ReturnStatus.ITEM_NOT_FROM_LIST_SUPPLIER]: 'Produkt ist nicht von Lieferant dieser Liste',
        [ReturnStatus.NOTIFICATION_NOT_FOUND]: 'Benachrichtigung nicht gefunden',
        [ReturnStatus.TAG_NOT_FOUND]: 'Kategorie nicht gefunden',
        [ReturnStatus.TAG_ALREADY_EXISTS]: 'Kategorie existiert schon',
        [ReturnStatus.USER_NOT_IN_TEAM]: 'Dieser Benutzer befindet sich nicht im Team',
        [ReturnStatus.TOKEN_INVALID]: 'Der eingegebene Code ist ungültig',
        [ReturnStatus.REMINDER_NOT_FOUND]: 'Die Bestellerinnerung nicht gefunden',
        [ReturnStatus.OWNER_CANT_BE_EDITED]: 'Der Besitzer darf nicht editiert werden',
        [ReturnStatus.PROMO_CODE_INVALID]: 'Gutschein-Code ist nicht gültig',
        [ReturnStatus.PROMO_CODE_INVALID_ALREADY_EXISTS]: 'Gutschein-Code wurde schon verwendet',
        [ReturnStatus.QUICK_START_CODE_INVALID]: 'Quickstart-Code ist ungültig',
        [ReturnStatus.SUPPLIER_ALREADY_EXISTS]: 'Lieferant existiert schon',
        [ReturnStatus.SUPPLIER_CUSTOMER_INVALID]: 'Locationlieferant ist ungültig',
        [ReturnStatus.LOCATION_ALREADY_EXISTS]: 'Location existiert schon',
        [ReturnStatus.JAVA_API_INTERNAL_SERVER_ERROR]: 'Ein Fehler ist aufgetreten',
        [ReturnStatus.NEWS_NOT_FOUND]: 'Nachricht nicht gefunden',
        [ReturnStatus.ORDER_MESSAGE_TOO_LONG]: 'Bestellnachricht überschreitet maximale Länge',
        [ReturnStatus.EMAIL_INVALID]: 'Email ist ungültig',
        [ReturnStatus.TOKEN_INVALID_ALREADY_USED]: 'Der eingegebene Code wurde schon verwendet',
        [ReturnStatus.SUPPLIER_BLOCKED]: 'Der Lieferant ist blockiert',
        [ReturnStatus.PROMOTION_EXPIRED]: 'Aktionsartikel abgelaufen'
    },
    scannedProductNotAvailable: "Das gescannte Produkt ist im Katalog Ihres Lieferanten nicht verfügbar, daher kann es nicht zur Scannerliste hinzugefügt werden.",
    scannerNotAvailable: "Es ist kein Scanner mit deinem Gerät verbunden. Bitte verbinde dich mit einem Scanner oder überprüfe deine bestehende Verbindung",
    chat: {
        loadMessages: "Nachrichten konnten nicht geladen werden",
        sendMessage: "Nachricht konnte nicht gesendet werden",
        openRoom: "Der Chat konnte nicht geöffnet werden",
        allowedMimeTypes: "Nur JPG-, PNG- oder PDF-Dateien sind erlaubt",
        maxSize: "Die Datei ist zu groß (max. {target} MB)",
        maxFilesPerMessage: "Maximal {target} Dateien pro Nachricht"
    }
}

export default error
